<template>
  <v-menu
    v-model="menuDate"
    transition="scale-transition"
    :close-on-content-click="false"
    offset-y
    min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="datesLabel"
          :label="$t('common.dateModal.selecioneData')"
          dense
          hide-details
          solo
          readonly
          v-on="on">
          <template v-slot:append>
            <v-icon v-on="on">
              event
            </v-icon>
          </template>
        </v-text-field>
      </template>

      <v-date-picker
        v-model="dates"
        :color="variables.colorPrimary"
        :close-on-content-click="false"
        no-title
        scrollable
        range>
        <!-- <v-spacer></v-spacer>
        <v-btn text color="primary" @click="showCalendar = false">Cancel</v-btn>
        <v-btn text color="primary" @click="showCalendar = false">OK</v-btn> -->
      </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { map } from 'lodash'
import variables from '@/assets/styles/helpers/_variables.scss'

export default {
  name: 'DateModalParceiros',
  props: {
    maxDateRange: {
      type: Number,
      default: null,
    }
  },
  data: () => ({
    datesLabel: [moment().add(-7, 'd').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
    dates: [moment().add(-7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    menuDate: false
  }),
  mounted () {
    this.$emit('update:dates', this.dates)
  },
  watch: {
    dates: {
      immediate: true,
      handler([firstDate, secondDate], lastDates) {
        this.$emit('update:dates', [firstDate, secondDate])
        const self = this
        const maxDate = moment(firstDate).isAfter(secondDate) ? firstDate : secondDate
        const minDate = moment(firstDate).isBefore(secondDate) ? firstDate : secondDate
        if (this.maxDateRange && Math.abs(moment(minDate).diff(moment(maxDate), 'days')) > this.maxDateRange && lastDates.length !== 2) {
          if (moment(firstDate).isAfter(secondDate)) {
            self.dates = [moment(maxDate).subtract(this.maxDateRange, 'days').format('YYYY-MM-DD'), maxDate]
          } else {
            self.dates = [minDate, moment(minDate).add(this.maxDateRange, 'days').format('YYYY-MM-DD')]
          }
        }
        self.sortedDates = map(map(self.dates, date => moment(date).valueOf()).sort(), time => moment(time).format('YYYY-MM-DD'))
        self.datesLabel = map(self.sortedDates, date => moment(date).format('DD/MM/YYYY')).join(' ~ ')
      }
    }
  },
  computed: {
    variables: () => variables,
  },
  methods: {
    closeModalDatePicker (date) {
      this.dateMonthString = moment(date, 'YYYY-MM').format('MMMM')
    },

    // testeDate (dateMonthString) {
    //   const testeDate =  moment(dateMonthString, 'MMMM', true)
    //   if (testeDate.isValid()) {
    //     this.dateMonth = moment(dateMonthString, 'MMMM').format('YYYY-MM')
    //   }
    // },
    
  }
}
</script>

<style>

</style>